import React from 'react';
import { Box, Typography } from '@mui/material';
import { FOUR_PILLARS, INTRO_CHIPS } from '../data/pricingContent';
import securePrivateIcon from '../../../../assets/pricing/secure_private.svg';
import accessAnywhereIcon from '../../../../assets/pricing/Access_anywhere.svg';
import builtForFamiliesIcon from '../../../../assets/pricing/buli_families.svg';
import prepareIcon from '../../../../assets/pricing/prepare.svg';
import protectIcon from '../../../../assets/pricing/protect.svg';
import respondIcon from '../../../../assets/pricing/respond.svg';
import recoverIcon from '../../../../assets/pricing/recover.svg';
import myRedFolderLogo from '../../../../assets/pricing/myredFolder.svg';

const CHIP_ICONS = {
  lock: securePrivateIcon,
  cloud: accessAnywhereIcon,
  home: builtForFamiliesIcon,
};

const PILLAR_ICONS = {
  prepare: prepareIcon,
  protect: protectIcon,
  respond: respondIcon,
  recover: recoverIcon,
};

const PricingIntroColumn = () => (
  <Box
    sx={{
      border: '1px solid #EAEAEA',
      borderRadius: 3,
      boxShadow: '0px 1px 20px #00000029',
      p: 2,
      backgroundColor: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    }}
  >
    <Typography sx={{ fontSize: { xs: 19, lg: 20 }, fontWeight: 700, color: '#202020', lineHeight: 1.3, textAlign: 'center' }}>
      Your family shouldn&apos;t have to figure out an emergency during the emergency.
    </Typography>
    <Typography sx={{ fontSize: 13.5, color: '#5B6270', mt: 1.5, lineHeight: 1.6, textAlign: 'center', px: { xs: 0, lg: 1 } }}>
      MYREDFOLDER® helps you prepare before something happens, stay connected when it does, protect the information that matters, document your property, and organize your recovery — all in one secure place.
    </Typography>

    <Box sx={{ display: 'flex', gap: 1.5, mt: 2.5 }}>
      {INTRO_CHIPS.map((chip) => (
        <Box
          key={chip.label}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            textAlign: 'left',
            gap: 1,
            backgroundColor: '#f9f9f9',
            border: '1px solid #c2c2c2',
            boxShadow: '0px 3px 6px #00000029',
            borderRadius: '8px',
            px: 1.2,
            py: 1.5,
            flex: '1 1 0',
            minWidth: 0,
            m: 0,
          }}
        >
          <Box component="img" src={CHIP_ICONS[chip.icon]} alt="" sx={{ width: 26, height: 26, flexShrink: 0 }} />
          <Typography sx={{ fontSize: 12.5, color: '#202020', lineHeight: 1.3 }}>
            {chip.label}
          </Typography>
        </Box>
      ))}
    </Box>

    <Box sx={{ mt: 3 }}>
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography sx={{ fontSize: 20, mb: 0.3, fontWeight: 700, color: '#1C2333' }}>
          Before. During. After.
        </Typography>
        <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: '#D13C3C' }}>
          THE FOUR-PILLAR PROMISE
        </Typography>
      </Box>

      <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {FOUR_PILLARS.map((pillar) => (
          <Box
            key={pillar.num}
            sx={{
              display: 'flex',
              alignItems: 'stretch',
              backgroundColor: '#FFFFFF',
              border: '1px solid #D8D8D8',
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                width: 72,
                backgroundColor: '#FDF7F8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Box component="img" src={PILLAR_ICONS[pillar.icon]} alt="" sx={{ width: 30, height: 30 }} />
            </Box>
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 1,
                p: 1.75,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#202020' }}>
                  {pillar.title}
                </Typography>
                <Typography sx={{ fontSize: 12.5, color: '#5B6270', mt: 0.25, lineHeight: 1.5 }}>
                  {pillar.description}
                </Typography>
              </Box>
              <Typography sx={{ fontSize: 14, color: '#D13C3C', flexShrink: 0 }}>
                {pillar.num}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>

    <Box
      sx={{
        mt: 'auto',
        borderRadius: 2,
        background: 'linear-gradient(135deg, #1a3763 0%, #d13c3c 100%)',
        color: '#fff',
        textAlign: 'center',
        py: 1.5,
        px: 1,
      }}
    >
      <Box component="img" src={myRedFolderLogo} alt="MYREDFOLDER®" sx={{ mx: 'auto', display: 'block' }} />
      <Typography sx={{ fontSize: 11, opacity: 1, mt: 1, mb: 0.5 }}>
        Stays with your family through the entire emergency lifecycle.
      </Typography>
    </Box>
  </Box>
);

export default PricingIntroColumn;
